"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var OpenClassConfigurationDialogModule = /** @class */ (function () {
    function OpenClassConfigurationDialogModule() {
    }
    return OpenClassConfigurationDialogModule;
}());
exports.OpenClassConfigurationDialogModule = OpenClassConfigurationDialogModule;
